/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './NlpPropertySearchService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchProperties
 */
export const SEARCH_PROPERTIES_QUERY_FIELD_NAME = 'com_hubspot_nlp_crm_search_rpc_propertysearch_NlpPropertySearchService_searchProperties';
export const SEARCH_PROPERTIES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_PROPERTIES_QUERY_FIELD_NAME,
  args: ['input', 'resultLimit', 'requesterName', 'correlationId', 'similarityThreshold', 'propertySearchFilters', 'returnDefaultsForEmptyInput'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.searchPropertiesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchPropertiesWithPaging
 */
export const SEARCH_PROPERTIES_WITH_PAGING_QUERY_FIELD_NAME = 'com_hubspot_nlp_crm_search_rpc_propertysearch_NlpPropertySearchService_searchPropertiesWithPaging';
export const SEARCH_PROPERTIES_WITH_PAGING_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_PROPERTIES_WITH_PAGING_QUERY_FIELD_NAME,
  args: ['input', 'requesterName', 'correlationId', 'similarityThreshold', 'propertySearchFilters', 'checkFieldLevelPermissions', 'resultLimit', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.searchPropertiesWithPagingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchPropertiesWithRankingData
 */
export const SEARCH_PROPERTIES_WITH_RANKING_DATA_QUERY_FIELD_NAME = 'com_hubspot_nlp_crm_search_rpc_propertysearch_NlpPropertySearchService_searchPropertiesWithRankingData';
export const SEARCH_PROPERTIES_WITH_RANKING_DATA_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_PROPERTIES_WITH_RANKING_DATA_QUERY_FIELD_NAME,
  args: ['input', 'resultLimit', 'requesterName', 'correlationId', 'similarityThreshold', 'propertySearchFilters', 'returnDefaultsForEmptyInput'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.searchPropertiesWithRankingDataRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchPropertiesReranked
 */
export const SEARCH_PROPERTIES_RERANKED_QUERY_FIELD_NAME = 'com_hubspot_nlp_crm_search_rpc_propertysearch_NlpPropertySearchService_searchPropertiesReranked';
export const SEARCH_PROPERTIES_RERANKED_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_PROPERTIES_RERANKED_QUERY_FIELD_NAME,
  args: ['propertySearchRequest', 'thresholdRuleDefinitions', 'numberOfRerankingCandidates'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.searchPropertiesRerankedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchProperty
 */
export const SEARCH_PROPERTY_QUERY_FIELD_NAME = 'com_hubspot_nlp_crm_search_rpc_propertysearch_NlpPropertySearchService_searchProperty';
export const SEARCH_PROPERTY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_PROPERTY_QUERY_FIELD_NAME,
  args: ['objectTypeId', 'guessedProperty', 'requesterName', 'correlationId', 'similarityThreshold', 'propertySearchFilters', 'returnDefaultsForEmptyInput'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.searchPropertyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchPropertyWithValues
 */
export const SEARCH_PROPERTY_WITH_VALUES_QUERY_FIELD_NAME = 'com_hubspot_nlp_crm_search_rpc_propertysearch_NlpPropertySearchService_searchPropertyWithValues';
export const SEARCH_PROPERTY_WITH_VALUES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_PROPERTY_WITH_VALUES_QUERY_FIELD_NAME,
  args: ['guessedProperty', 'guessedValue', 'requesterName', 'correlationId', 'propertySearchFilters'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.searchPropertyWithValuesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#searchPropertyAndResolveValues
 */
export const SEARCH_PROPERTY_AND_RESOLVE_VALUES_QUERY_FIELD_NAME = 'com_hubspot_nlp_crm_search_rpc_propertysearch_NlpPropertySearchService_searchPropertyAndResolveValues';
export const SEARCH_PROPERTY_AND_RESOLVE_VALUES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_PROPERTY_AND_RESOLVE_VALUES_QUERY_FIELD_NAME,
  args: ['guessedProperty', 'guessedValues', 'requesterName', 'correlationId', 'similarityThreshold', 'propertySearchFilters', 'returnDefaultsForEmptyInput'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.searchPropertyAndResolveValuesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService#recordPropertyClickedEvent
 */
export const RECORD_PROPERTY_CLICKED_EVENT_QUERY_FIELD_NAME = 'com_hubspot_nlp_crm_search_rpc_propertysearch_NlpPropertySearchService_recordPropertyClickedEvent';
export const RECORD_PROPERTY_CLICKED_EVENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: RECORD_PROPERTY_CLICKED_EVENT_QUERY_FIELD_NAME,
  args: ['input', 'servedResponseResults', 'clickedResult', 'correlationId', 'requesterName', 'similarityThreshold', 'propertySearchFilters'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.recordPropertyClickedEventRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});